import feature1 from "../assets/Rectangle-4.png";
import feature2 from "../assets/Rectangle-3.png";
import feature3 from "../assets/Rectangle-2.png";
import feature4 from "../assets/Rectangle.png";
import googleImg from "../assets/image 1.png";
import appStoreImg from "../assets/image 2.png";

function KeyFeatures() {
  const features = [
    {
      img: feature1,
      alt: "Quick Reporting",
      title: "Quick & Easy Reporting",
      text: "Capture an incident, describe it, and submit. Your report is geo-tagged and tracked instantly.",
    },
    {
      img: feature2,
      alt: "SOS Alerts",
      title: "One-Tap SOS Alerts",
      text: "In danger or distress? Tap the SOS button to notify emergency responders and your trusted contacts.",
    },
    {
      img: feature3,
      alt: "Earn Rewards",
      title: "Earn for Every Approved Report",
      text: `Get points for each validated report. Redeem them as:\nCoupons from partner merchants or bank withdrawals straight to your preferred account.`,
    },
    {
      img: feature4,
      alt: "Smart Routing",
      title: "Smart Location Routing",
      text: "Reports are automatically routed to the right authorities using your current location.",
    },
  ];

  return (
    <section id="features" className="py-5 bg-success text-white">
      <div className="container">
        <h2 className="text-center fw-bold mb-5">Key Features</h2>

        <div className="row g-4">
          {features.map((feature, i) => (
            <div className="col-md-6 col-lg-3" key={i}>
              <div className="bg-white text-dark rounded-4 shadow-sm text-center h-100 d-flex flex-column">
                <img
                  src={feature.img}
                  alt={feature.alt}
                  className="img-fluid rounded mb-3"
                />
                <div
                  className="key-features-card-bg px-3 py-4 flex-grow-1 d-flex flex-column "
                  style={{ minHeight: "200px", whiteSpace: "pre-wrap" }}
                >
                  <h5 className="fw-bold">{feature.title}</h5>
                  <p className="small">{feature.text}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* App store buttons */}
        <div className="d-flex justify-content-center gap-3 mt-5">
          <a href="https://play.google.com/">
            <img src={googleImg} alt="Google Play" height="45" />
          </a>
          <a href="https://play.google.com/">
            <img src={appStoreImg} alt="App Store" height="45" />
          </a>
        </div>
      </div>
    </section>
  );
}

export default KeyFeatures;
